module.exports = "/dist/5e334eff013f12fbb8ed72c2a253f119.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100.woff
// module id = 108
// module chunks = 0